module.exports = __webpack_public_path__ + "img/48.73b9ead4.png";